import { motion } from "framer-motion";
import { allGalleryImages } from "../../data/galleryData";

export default function GallerySection() {
  return (
    <section className="py-16 md:py-20 bg-aura-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-12">
          <span className="block font-sans text-xs md:text-sm font-medium uppercase tracking-[0.25em] text-gold-dark mb-3">
            Gallery
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-aura-text">
            Moments from our work
          </h2>
          <p className="mt-4 font-sans text-sm md:text-base text-aura-text">
            A glimpse into the events, experiences, and environments we create for
            our clients.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {allGalleryImages.slice(0, 6).map((image, i) => (
            <motion.div
              key={image.src}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className={`group relative overflow-hidden rounded-xl border border-gold-light/20 bg-gold-light/10 ${
                i === 0 ? "md:row-span-2 md:col-span-2" : ""
              }`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

